import { MediaUpload } from "features/media/media.types"
import { Attachment, AttachmentTypeEnum } from "suus-api"

export interface AttachmentMediaUpload extends MediaUpload {
  attachmentId?: string
  frontendId: string
  storedFile?: Promise<string>
  fullImageUrl?: string
  attachmentType?: AttachmentTypeEnum
  mimeContentType?: string
}

export function attachmentToAttachmentMediaUpload(
  attachment: Attachment
): AttachmentMediaUpload {
  const {
    id,
    frontend_id,
    name,
    file_type_extension,
    links,
    type,
    content_type,
  } = attachment

  return {
    attachmentId: id.toString(),
    frontendId: frontend_id,
    name,
    type: file_type_extension,
    thumbDataUrl: links.thumb_url,
    fullImageUrl: links.original_url,
    attachmentType: type,
    mimeContentType: content_type,
  }
}
